import React from 'react';
import PermissionGate from '../components/atoms/permissionsGate/permissionsGate';

const withPermission = (scopes, element, restrictPage = true) => {
  return (
    <PermissionGate scopes={scopes} restrictPage={restrictPage}>
      {element}
    </PermissionGate>
  );
};

export default withPermission;